import {
    Routes,
    Route,
    BrowserRouter as Router,
    Navigate,
} from "react-router-dom";
import { useAuth } from "./context/authContext";
import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import MobileUploadPage from "./pages/MobileUploadPage";
import PatientNewPage from "./pages/patients/PatientNewPage";
import PatientPage from "./pages/patients/PatientPage";
import UserNewPage from "./pages/users/UserNewPage";
import UserPage from "./pages/users/UserPage";
import PatientDetailPage from "./pages/patients/PatientDetailPage";
import ProfilePage from "./pages/profile/ProfilePage";
import ConsultationNewPage from "./pages/patients/ConsultationNewPage";
import PatientDocumentsPage from "./pages/patients/PatientDocumentsPage";
import PatientCallerPage from "./pages/caller/PatientCallerPage";
import WaitingRoomPage from "./pages/WaitingRoomPage";
import ConsultationHistoryPage from "./pages/patients/ConsultationHistory";
import CheckTurnPage from "./pages/CheckTurnPage";
import GeneralDataPage from "./pages/reports/GeneralDataPage";
import SurgeriesPage from "./pages/reports/SurgeriesPage";
import StudiesPage from "./pages/reports/StudiesPage";
import MedicationPage from "./pages/reports/MedicationPage";
import TurnsPage from "./pages/TurnsPage";
import NoticesPage from "./pages/NoticesPage";
import BackgroundImagePage from "./pages/BackgroundImagePage";
import { SchedulePage } from "./pages/schedule/SchedulePage";
import { ThemeProvider } from "./context/themeContext";
import { AgendaPage } from "./pages/schedule/agenda/AgendaPage";
import { DoctorAgenda } from "./pages/schedule/agenda/DoctorAgenda";
import { ConfirmAppointment } from "./pages/schedule/ConfirmAppointment";
import { ScheduleProvider } from "./context/ScheduleContext";
import { SystemConfigProvider } from "./context/systemConfigContext";
import ReportPage from "./pages/patients/ReportPage";
import AgendamientosPage from "./pages/agendamientos/AgendamientosPage";
import DatosPersonalesPage from "./pages/agendamientos/DatosPersonalesPage";
import DatosContactoPage from "./pages/agendamientos/DatosContactoPage";
import SeleccionarDoctorPage from "./pages/agendamientos/SeleccionarDoctorPage";
import SeleccionarTurnoPage from "./pages/agendamientos/SeleccionarTurnoPage";
import CitaConfirmadaPage from "./pages/agendamientos/CitaConfirmadaPage";
import MyConsultationsPage from "./pages/consultations/MyConsultationsPage";
import PrintTemplatesPage from "./pages/settings/PrintTemplatesPage";
import PrintTemplateEditPage from "./pages/settings/PrintTemplateEditPage";

function App() {
    const auth = useAuth();

    const authenticatedRoutes = (
        <Routes>
            <Route path="/m/upload/:token" element={<MobileUploadPage />} />
            <Route path="/" element={<Navigate to="/patients" />} />
            <Route exact path="/patients" element={<PatientPage />} />
            <Route exact path="/patients/new" element={<PatientNewPage />} />
            <Route
                path="/patients/:idPatient"
                element={<PatientDetailPage />}
            />
            <Route
                path="/patients/:idPatient/edit"
                element={<PatientNewPage />}
            />
            <Route
                path="/patients/:idPatient/new"
                element={<ConsultationNewPage />}
            />
            <Route
                path="/patients/:idPatient/documents"
                element={<PatientDocumentsPage />}
            />
            <Route
                path="/patients/:idPatient/history"
                element={<ConsultationHistoryPage />}
            />
            <Route
                path="/patients/:idPatient/reports"
                element={<ReportPage />}
            />
            <Route
                path="/patients/:idPatient/history"
                element={<ConsultationHistoryPage />}
            />
            <Route
                path="/patients/:idPatient/consultations/:idConsultation"
                element={<ConsultationNewPage />}
            />
            <Route exact path="/users" element={<UserPage />} />
            <Route exact path="/users/new" element={<UserNewPage />} />
            <Route path="/users/:idUser" element={<UserNewPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/turns" element={<PatientCallerPage />} />
            <Route path="/turns-list" element={<TurnsPage />} />
            <Route
                path="/reports/general-data-report"
                element={<GeneralDataPage />}
            />
            <Route path="/reports/surgery-report" element={<SurgeriesPage />} />
            <Route path="/reports/study-report" element={<StudiesPage />} />
            <Route
                path="/reports/medication-report"
                element={<MedicationPage />}
            />
            <Route path="/check-turn" element={<CheckTurnPage />} />
            <Route path="/lobby" element={<WaitingRoomPage />} />
            <Route path="/notice" element={<NoticesPage />} />
            <Route path="/image" element={<BackgroundImagePage />} />
            <Route
                path="/schedule"
                element={
                    <ScheduleProvider>
                        <SchedulePage />
                    </ScheduleProvider>
                }
            />
            <Route
                path="/consultations/mine"
                element={<MyConsultationsPage />}
            />
            <Route
                path="/settings/print-templates"
                element={<PrintTemplatesPage />}
            />
            <Route
                path="/settings/print-templates/:id"
                element={<PrintTemplateEditPage />}
            />
            <Route path="/schedule/agenda" element={<AgendaPage />} />
            <Route
                path="/schedule/agenda/:idSchedule/:doctor"
                element={<DoctorAgenda />}
            />
        </Routes>
    );

    return (
        <div>
            <ThemeProvider>
                <SystemConfigProvider>
                    <Router className="min-h-screen bg-white dark:bg-gray-900 text-black dark:text-white transition-colors duration-300">
                        {auth.isAuthenticated ? (
                            authenticatedRoutes
                        ) : (
                            <Routes>
                                <Route path="/m/upload/:token" element={<MobileUploadPage />} />
                                <Route path="/login" element={<LoginPage />} />
                                <Route
                                    path="/reset-password/:uuid/:token"
                                    element={<ResetPasswordPage />}
                                />
                                <Route
                                    path="/lobby"
                                    element={<WaitingRoomPage />}
                                />
                                <Route
                                    path="/check-turn"
                                    element={<CheckTurnPage />}
                                />
                                <Route
                                    path="/reserve"
                                    element={<AgendamientosPage />}
                                />
                                <Route
                                    path="/reserve/personal-data"
                                    element={<DatosPersonalesPage />}
                                />
                                <Route
                                    path="/reserve/contact-data"
                                    element={<DatosContactoPage />}
                                />
                                <Route
                                    path="/reserve/select-doctor"
                                    element={<SeleccionarDoctorPage />}
                                />
                                <Route
                                    path="/reserve/select-slot"
                                    element={<SeleccionarTurnoPage />}
                                />
                                <Route
                                    path="/reserve/confirmed"
                                    element={<CitaConfirmadaPage />}
                                />

                                <Route
                                    path="/appointments"
                                    element={<Navigate to="/reserve" replace />}
                                />
                                <Route
                                    path="/appointments/personal-data"
                                    element={
                                        <Navigate
                                            to="/reserve/personal-data"
                                            replace
                                        />
                                    }
                                />
                                <Route
                                    path="/appointments/contact-data"
                                    element={
                                        <Navigate
                                            to="/reserve/contact-data"
                                            replace
                                        />
                                    }
                                />
                                <Route
                                    path="/appointments/select-doctor"
                                    element={
                                        <Navigate
                                            to="/reserve/select-doctor"
                                            replace
                                        />
                                    }
                                />
                                <Route
                                    path="/appointments/select-slot"
                                    element={
                                        <Navigate
                                            to="/reserve/select-slot"
                                            replace
                                        />
                                    }
                                />
                                <Route
                                    path="/appointments/confirmed"
                                    element={
                                        <Navigate
                                            to="/reserve/confirmed"
                                            replace
                                        />
                                    }
                                />

                                <Route
                                    path="/agendamientos"
                                    element={<Navigate to="/reserve" replace />}
                                />
                                <Route
                                    path="/reservas"
                                    element={<Navigate to="/reserve" replace />}
                                />
                                <Route
                                    path="/agendamientos/datos-personales"
                                    element={
                                        <Navigate
                                            to="/reserve/personal-data"
                                            replace
                                        />
                                    }
                                />
                                <Route
                                    path="/agendamientos/datos-contacto"
                                    element={
                                        <Navigate
                                            to="/reserve/contact-data"
                                            replace
                                        />
                                    }
                                />
                                <Route
                                    path="/agendamientos/seleccionar-doctor"
                                    element={
                                        <Navigate
                                            to="/reserve/select-doctor"
                                            replace
                                        />
                                    }
                                />
                                <Route
                                    path="/agendamientos/seleccionar-turno"
                                    element={
                                        <Navigate
                                            to="/reserve/select-slot"
                                            replace
                                        />
                                    }
                                />
                                <Route
                                    path="/agendamientos/cita-confirmada"
                                    element={
                                        <Navigate
                                            to="/reserve/confirmed"
                                            replace
                                        />
                                    }
                                />
                                <Route
                                    path="*"
                                    element={<Navigate to="/login" />}
                                />
                                <Route
                                    path="/confirm/:idAppointment"
                                    element={<ConfirmAppointment />}
                                />
                            </Routes>
                        )}
                    </Router>
                </SystemConfigProvider>
            </ThemeProvider>
        </div>
    );
}

export default App;
